const Ether = () => (
    <svg
        width='44'
        height='44'
        viewBox='0 0 44 44'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle cx='22' cy='22' r='22' fill='white' />
        <g opacity='0.6'>
            <path
                d='M22.1912 17.2744L12 21.9093L22.1912 27.9303L32.3785 21.9093L22.1912 17.2744Z'
                fill='#010101'
            />
        </g>
        <g opacity='0.45'>
            <path d='M12 21.9093L22.1912 27.9303V5L12 21.9093Z' fill='#010101' />
        </g>
        <g opacity='0.8'>
            <path d='M22.1912 5V27.9303L32.3784 21.9093L22.1912 5Z' fill='#010101' />
        </g>
        <g opacity='0.45'>
            <path d='M12 23.8401L22.1912 38.1976V29.8612L12 23.8401Z' fill='#010101' />
        </g>
        <g opacity='0.8'>
            <path
                d='M22.1912 29.8612V38.1976L32.3864 23.8401L22.1912 29.8612Z'
                fill='#010101'
            />
        </g>
    </svg>
);
export default Ether;
